// 个人主页
const archiveRouter = {
  path: '/archive',
  name: 'Archive',
  component: () => import('@/components/homepage/homepageTop.vue'),
  children: [
    {
      path: '/',
      name: 'archiveIndex',
      meta: {
        title: '我的主页',
        type: 'login'
      },
      component: () => import('@/views/mine/homepage/subjects.vue')
    },
    {
      path: 'archiveInfo',
      name: 'ArchiveInfo',
      meta: {
        title: '我的主页',
        type: 'login'
      },
      component: () => import('@/views/mine/homepage/archive.vue')
    }
  ]
}
export default archiveRouter
